import { FloorplanPlacement, FloorplanPlacementSection } from 'floorplan/pages/native-floorplan/types';

/**
 * The sections a floor's placements belong to, deduplicated and in the admin's order.
 *
 * Derived from the placements rather than fetched: sections reach the miniapp only as part of the
 * availability response, and a section with nothing placed on this floor could not be filtered to
 * anyway — offering it would be a chip that empties the map.
 */
export const collectSections = (placements: FloorplanPlacement[]): FloorplanPlacementSection[] => {
  const byUuid = new Map<string, FloorplanPlacementSection>();

  placements.forEach(({ sections }) => sections.forEach(section => byUuid.set(section.uuid, section)));

  return [...byUuid.values()].sort((a, b) => a.sortOrder - b.sortOrder);
};

/** A placement can sit in more than one section, so this is a membership test, not an equality one. */
export const matchesSection = (placement: FloorplanPlacement, sectionUuid: string | null): boolean =>
  !sectionUuid || placement.sections.some(({ uuid }) => uuid === sectionUuid);

/**
 * The section filter as it applies to the floor on screen.
 *
 * Sections belong to the building, not to one floor, and the filter survives a floor switch — so the
 * url can name a section that has nothing placed on the floor now being shown. Falling back to "no
 * filter" is what keeps the map and the sheet telling the same story: the chips would highlight
 * nothing (the section is not among them), while the map would dim every last placement.
 */
export const resolveSelectedSection = (
  sections: FloorplanPlacementSection[],
  selectedUuid: string | null,
): string | null => (sections.some(({ uuid }) => uuid === selectedUuid) ? selectedUuid : null);
